import { yupResolver } from '@hookform/resolvers/yup'
import PropTypes from 'prop-types'
import { FormProvider, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import SidePopover from '@/components/side-popover/SidePopover.jsx'
import BillingForm from '@/pages/customers/detail/customer-form/billing-form/BillingForm.jsx'
import {
    DEFAULT_BILLING_MOCK,
    validationSchema,
} from '@/pages/customers/detail/customer-form/billing-form/billing.schema.js'

const CustomerBillingFormWrapper = ({
    dataForm,
    closeModal,
    openDialogDelete,
    isEdit,
    isFinance,
}) => {
    const { t } = useTranslation()

    const methods = useForm({
        shouldUnregister: false,
        mode: 'all',
        reValidateMode: 'onChange',
        nativeValidation: false,
        shouldFocusError: true,
        resolver: yupResolver(validationSchema),
        defaultValues: DEFAULT_BILLING_MOCK,
    })

    const {
        formState: { isDirty },
    } = methods
    return (
        <FormProvider {...methods}>
            <SidePopover
                onClose={() => closeModal(isDirty)}
                isDirty={isDirty}
                title={
                    isEdit
                        ? t('customers.billing_edit_title')
                        : t('customers.billing_create_title')
                }
            >
                <BillingForm
                    isEdit={isEdit}
                    closeModal={closeModal}
                    dataForm={dataForm}
                    openDialogDelete={openDialogDelete}
                    isFinance={isFinance}
                />
            </SidePopover>
        </FormProvider>
    )
}

export default CustomerBillingFormWrapper

CustomerBillingFormWrapper.propTypes = {
    dataForm: PropTypes.object,
    onClose: PropTypes.func,
    closeModal: PropTypes.func,
    openDialogDelete: PropTypes.func,
    isEdit: PropTypes.bool,
    isFinance: PropTypes.bool,
}
